export const CLIENT_STORE = 'CLIENT_STORE';
export const CLIENT_UPDATE = 'CLIENT_UPDATE';
export const CLIENT_DESTROY = 'CLIENT_DESTROY';
